/* eslint-disable react/prop-types */
import React from 'react'

import { IconProps } from '.'

const GenderGirl: React.FC<IconProps> = ({ size = 16, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      {...rest}
    >
      <path
        fill="#595959"
        d="M11.445 8.979a4.875 4.875 0 000-6.888 4.879 4.879 0 00-6.89 0 4.875 4.875 0 000 6.888 4.849 4.849 0 002.872 1.39V12H6.28a.573.573 0 100 1.147h1.147v1.614a.573.573 0 001.146 0v-1.614H9.72a.573.573 0 100-1.146H8.573v-1.63a4.849 4.849 0 002.872-1.391zm-6.08-.81a3.728 3.728 0 010-5.268 3.73 3.73 0 015.27 0 3.728 3.728 0 010 5.267 3.73 3.73 0 01-5.27 0z"
      ></path>
      <path
        fill="#595959"
        fillRule="evenodd"
        d="M5.366 8.168a3.73 3.73 0 005.268 0 3.728 3.728 0 000-5.267 3.73 3.73 0 00-5.268 0 3.728 3.728 0 000 5.267zm6.15-6.148a4.975 4.975 0 010 7.03 4.948 4.948 0 01-2.843 1.407V11.9H9.72a.673.673 0 110 1.346H8.673v1.514a.673.673 0 01-1.346 0v-1.514H6.28a.673.673 0 110-1.346h1.046v-1.443A4.948 4.948 0 014.484 9.05a4.975 4.975 0 010-7.029 4.979 4.979 0 017.032 0zm-4.09 8.35a4.849 4.849 0 01-2.871-1.391 4.875 4.875 0 010-6.888 4.879 4.879 0 016.89 0 4.875 4.875 0 010 6.888 4.849 4.849 0 01-2.872 1.39V12H9.72a.573.573 0 110 1.147H8.573v1.614a.573.573 0 01-1.146 0v-1.614H6.28a.573.573 0 110-1.146h1.147v-1.63zm-1.99-7.398a3.628 3.628 0 000 5.126 3.63 3.63 0 005.128 0 3.628 3.628 0 000-5.126 3.63 3.63 0 00-5.128 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default GenderGirl
